import states from '../data/usaStates/states.json';

export const getAllStates = () => {
  return states.states;
};
